export const TENANT = window.location.hostname.split('.')[0];

export const ISO_DATE_REGEX =
  /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z)$/;
